<template>
  <div class="text-left" ref="editorRef" />
</template>

<script setup lang="ts">
import { type Content, createJSONEditor, type OnChange } from "vanilla-jsoneditor";
import { type PropType, onUnmounted, ref, watch } from "vue";

const editor = ref();
const editorRef = ref();

const props = defineProps({
  content: Object as PropType<Content>,
  onChange: Object as PropType<OnChange>,
});

watch(
  () => editorRef.value,
  () => {
    editor.value = createJSONEditor({
      target: editorRef.value,
      props: {
        content: props.content,
        onChange: props.onChange,
      },
    });
  },
  { once: true },
);

onUnmounted(() => {
  if (editorRef.value) {
    editorRef.value.destroy();
    editorRef.value = null;
  }
});

watch(
  () => props.content,
  () => {
    if (editor.value) editor.value.updateProps(props);
  },
  {
    deep: true,
    immediate: true,
  },
);
</script>
